module.exports = __webpack_public_path__ + "img/arrow.2025119e.svg";